import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Route } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { select, Store } from '@ngrx/store';
import Debug from 'debug';
import { Observable, Subscription } from 'rxjs';
import * as fromLayoutActions from '../../ngrx/aumico.layout.action';
import { INavigationEvent } from '../../ngrx/aumico.layout.action';
import { AumicoCoreLayoutProvider } from '../../ngrx/aumico.layout.provider';
import * as fromLayout from '../../ngrx/aumico.layout.reducer';
import { ActionFooterService } from '../../services/actionFooter.service';

const debug = Debug('aumico:aumico-lib-core-fe:ActionFooterComponent');
@UntilDestroy()
@Component({
    selector: 'aumico-action-footer',
    templateUrl: './action-footer.component.html',
    styleUrls: ['./action-footer.component.scss'],
})
export class ActionFooterComponent implements OnInit, OnDestroy {
    pageName$: Observable<Route>;
    activeUser = 1;

    subscriptions: Subscription[] = [];
    hideFooterOption = false;
    public strangerElementToDisplay: ElementRef | null = null;

    constructor(
        private layoutStore: Store<fromLayout.ModuleState>,
        private actionFooterService: ActionFooterService,
        private renderer: Renderer2,
        private elRef: ElementRef,
        private aumicoCoreLayoutProvider: AumicoCoreLayoutProvider,
    ) {
        this.handleHideFooterOption = this.handleHideFooterOption.bind(this);
    }

    ngOnInit() {
        this.pageName$ = this.layoutStore.pipe(select(fromLayout.selectActivePage));

        this.aumicoCoreLayoutProvider
            .getHideFooterOption$()
            .pipe(untilDestroyed(this))
            .subscribe(this.handleHideFooterOption);

        debug('movePagerToGlobalView subscribe');
        this.actionFooterService.pagingActionBar$.subscribe(this.displayStrangerElemenet.bind(this));
    }

    handleHideFooterOption(hideOptions: boolean) {
        this.hideFooterOption = hideOptions;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscriber: Subscription) => {
            subscriber.unsubscribe();
        });
    }

    displayStrangerElemenet(newStranger: ElementRef) {
        debug('movePagerToGlobalView add:', newStranger);

        if (this.strangerElementToDisplay) {
            debug('movePagerToGlobalView detach:', this.strangerElementToDisplay);
            if (this.strangerElementToDisplay != null) {
                try {
                    this.renderer.removeChild(this.elRef.nativeElement, this.strangerElementToDisplay.nativeElement);
                } catch (error) {
                    debug('movePagerToGlobalView detach failed:', this.strangerElementToDisplay, error);
                }
            }
        }
        this.strangerElementToDisplay = newStranger;
        if (newStranger) {
            this.renderer.appendChild(this.elRef.nativeElement, newStranger.nativeElement);
            this.renderer.setStyle(newStranger.nativeElement, 'width', '100%');
        }
    }

    onSetPageName() {
        const event: INavigationEvent = {
            route: { data: { label: 'Test' } },
        };
        this.layoutStore.dispatch(fromLayoutActions.onPageNavigation({ payload: event }));
    }

    onChangeTab() {
        const event: INavigationEvent = {
            route: { data: { label: 'Print' } },
        };
        this.layoutStore.dispatch(fromLayoutActions.onSubNavigation({ payload: event }));
    }
}
